module.exports = __webpack_public_path__ + "graphics/gauges/chart-low.png";